<template>
  <div class="box solution" :class="{ 'is-reverse': isReverse }">
    <div class="columns">
      <div class="column is-4">
        <figure class="image is-256x256">
          <img :src="data.img" :alt="data.title">
        </figure>
      </div>

      <div class="column is-8 content">
        <p class="subsection-title lvl1"><strong>{{ data.title }}</strong></p>
        <p v-html="data.description"></p>
        <router-link :to="data.to">LEARN MORE</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    isReverse: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductCard.vue